import React from 'react';
import { Tabs } from 'antd';
import GelirGiderTablosu from './GelirGiderTablosu';
import IncelemeRaporu from './IncelemeRaporu';

function Raporlama() {
  const tabItems = [
    {
      key: 'gelir-gider',
      label: <span style={{ display: 'inline-block', whiteSpace: 'pre-line', lineHeight: 1.2, textAlign: 'center' }}>{'Gelir/Gider\nTablosu'}</span>,
      children: <GelirGiderTablosu />
    },
    {
      key: 'inceleme',
      label: <span style={{ display: 'inline-block', whiteSpace: 'pre-line', lineHeight: 1.2, textAlign: 'center' }}>{'İnceleme\nRaporu'}</span>,
      children: <IncelemeRaporu />
    }
  ];

  return (
    <div>
      <h2 style={{ marginBottom: 16 }}>Raporlama</h2>
      <Tabs items={tabItems} defaultActiveKey="gelir-gider" />
    </div>
  );
}

export default Raporlama;
